module.exports = __webpack_public_path__ + "static/media/g.68f42292.m4a";